export default __webpack_public_path__ + "23b121f889992270e275a5b6479b482f.svg";